export default [
  {
    component: 'CNavItem',
    name: 'Zamówienia',
    to: '/orders',
    icon: 'cil-list',
  },
  {
    component: 'CNavItem',
    name: 'Zamówienia',
    to: '/page-owner/orders',
    icon: 'cil-list',
    pageOwnerOnly: true,
  },
  {
    component: 'CNavItem',
    name: 'Realizacje',
    to: '/realizations',
    icon: 'cil-task',
  },
  {
    component: 'CNavItem',
    name: 'Oddziały',
    to: '/branches',
    icon: 'cil-star',
  },
  {
    component: 'CNavItem',
    name: 'Zapytania hurtowe',
    to: '/wholesale-inquiries',
    icon: 'cil-list',
  },
  {
    component: 'CNavItem',
    name: 'Kalendarz dostępności',
    to: '/calendar',
    icon: 'cil-calendar',
  },
  {
    component: 'CNavItem',
    name: 'Cenniki najmu',
    to: '/price-lists',
    icon: 'cil-dollar',
  },
  {
    component: 'CNavItem',
    name: 'Cennik dodatków',
    to: '/additional-services-price',
    icon: 'cil-dollar',
  },
]
